<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        @click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <OsTestsList :click="onClickButton" />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import OsTestsList from '@/components/osTests/OsTestsList'

export default {
  name: 'OsTests',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    OsTestsList
  },
  
  methods: {
    onClickButton() {
      $('#modalOpenOs').modal('show')
    }
  }
}
</script>
